import { Injectable, NgModule } from '@angular/core';
import { CreateSEModalComponent } from './create-se-modal.component';
import { BaseModule } from '../../shared/base.module';
import { MyDatePickerModule } from 'mydatepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import {PopoverModule} from 'ngx-bootstrap/popover';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {TinymceModule} from 'angular2-tinymce';
import { QuestionnairesService } from '../questionnaires/questionnaires.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DialogModule } from '../../dialog/dialog.module';
import { PatientsService } from '../../patients/patients.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
    imports: [
        BaseModule,
        MyDatePickerModule,
        DialogModule,
        ModalModule.forRoot(),
        MatInputModule,
        MatSelectModule,
        PopoverModule.forRoot(),
        TooltipModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect'
        }),
        MatSlideToggleModule
    ],
    exports: [CreateSEModalComponent],
    declarations: [CreateSEModalComponent],
    providers: [
        QuestionnairesService,
        PatientsService,
        // { provide: 'HELP_PATIENT_LIST', useValue: HELP_PATIENT_LIST },
    ],
})

export class CreateSEModalModule {
}
